/**
 * Compact label for the attach/detach action itself — the row-menu item and
 * the bulk-selection-bar button. Kept short ("Attach/Detach") because the
 * long "Attached / Detached to Wheels" copy truncated where this used to
 * double as the AttachWheelModal heading too (Kelly's call).
 */
export const ATTACH_DETACH_WHEELS_LABEL = "Attach/Detach";

/**
 * ISP-9999 — the AttachWheelModal's own DialogTitle now uses this instead of
 * ATTACH_DETACH_WHEELS_LABEL: every sibling modal heading is Title Case
 * ("New capture", "Delete capture?"), and the lowercase action-menu label
 * read as a mistake sitting at the top of a dialog. Still short enough not
 * to reintroduce the truncation above.
 */
export const ATTACH_WHEEL_MODAL_HEADING = "Attach / Detach";
